export const call = {
  status: {
    answered: 'Отвечено',
    busy: 'Занято',
    no_answer: 'Без ответа',
    failed: 'Ошибка',
    active: 'Активный',
    error: 'Ошибка',
    processing: 'В процессе'
  },

  type: {
    outgoing: 'Исходящий',
    incoming: 'Входящий'
  }
};
